import { twMerge } from 'tailwind-merge';

import { cs } from '@/_shared';

import type { DivProps } from '../../types';

export function Skeleton({ className, ...rest }: DivProps) {
  return (
    <div
      data-slot="skeleton"
      {...rest}
      className={twMerge(
        'h-2 w-full animate-pulse bg-gray-300/70 dark:bg-gray-900',
        'rounded-lg',
        cs('rounded-2xl'),
        className
      )}
    />
  );
}

export function CircleSkeleton({ className, ...rest }: DivProps) {
  return (
    <div
      data-slot="skeleton"
      {...rest}
      className={twMerge(
        'size-3 shrink-0 grow-0 animate-pulse rounded-full bg-gray-300/70 dark:bg-gray-900',
        className
      )}
    />
  );
}
